import source from "../../../content/blog/source.md?raw";

import { parseBlogMarkdownSource, type BlogPost } from "./parse-blog-markdown-source";

export type { BlogPost };

let cached: BlogPost[] | null = null;

function allPosts(): BlogPost[] {
  if (!cached) cached = parseBlogMarkdownSource(source);
  return cached;
}

export function getBlogPostBySlugBrowser(slug: string): BlogPost | null {
  return allPosts().find((p) => p.slug === slug) ?? null;
}

/** Newest first (publish date desc). */
export function getBlogPostsSortedBrowser(): BlogPost[] {
  return [...allPosts()].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
}
